import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["components", "selectRef", "cacheUniqs"];
import { useComponents } from 'react-select-async-paginate';
import { useSelectFetch } from './useSelectFetch';
import { jsx as _jsx } from "react/jsx-runtime";
export function withSelectFetch( // eslint-disable-next-line @typescript-eslint/naming-convention
SelectComponent) {
  function WithSelectFetch(props) {
    var components = props.components,
        selectRef = props.selectRef,
        cacheUniqs = props.cacheUniqs,
        rest = _objectWithoutProperties(props, _excluded);

    var asyncPaginateProps = useSelectFetch(rest, cacheUniqs);
    var processedComponents = useComponents(components);
    return /*#__PURE__*/_jsx(SelectComponent, _objectSpread(_objectSpread(_objectSpread({}, props), asyncPaginateProps), {}, {
      components: processedComponents,
      ref: selectRef
    }));
  }

  WithSelectFetch.defaultProps = {
    selectRef: null,
    cacheUniqs: [],
    components: {}
  };
  return WithSelectFetch;
}